
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M4.64997 9.34997L2.69997 11.3C2.30997 11.69 2.30997 12.32 2.69997 12.71L4.64997 14.66C5.13997 15.15 5.92997 15.15 6.41997 14.66C6.89997 14.17 6.89997 13.39 6.41997 12.9L5.53997 12L6.41997 11.11C6.89997 10.62 6.89997 9.83997 6.41997 9.34997C5.93997 8.85997 5.13997 8.85997 4.64997 9.34997ZM17.58 9.34997C17.1 9.83997 17.1 10.62 17.58 11.11L18.46 12L17.58 12.89C17.1 13.38 17.1 14.16 17.58 14.65C18.07 15.14 18.86 15.14 19.35 14.65L21.3 12.7C21.69 12.31 21.69 11.68 21.3 11.29L19.35 9.33997C18.86 8.85997 18.06 8.85997 17.58 9.34997ZM12 18.46L11.11 17.58C10.62 17.1 9.83997 17.1 9.34997 17.58C8.85997 18.07 8.85997 18.86 9.34997 19.35L11.3 21.3C11.69 21.69 12.32 21.69 12.71 21.3L14.66 19.35C15.15 18.86 15.15 18.07 14.66 17.58C14.17 17.1 13.39 17.1 12.9 17.58L12 18.46ZM9.34997 6.41997C9.83997 6.89997 10.62 6.89997 11.11 6.41997L12 5.53997L12.89 6.41997C13.38 6.89997 14.16 6.89997 14.65 6.41997C15.14 5.92997 15.14 5.13997 14.65 4.64997L12.7 2.69997C12.31 2.30997 11.68 2.30997 11.29 2.69997L9.34997 4.64997C8.85997 5.13997 8.85997 5.93997 9.34997 6.41997Z' fill='#323232'/><path d='M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-control-camera`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconControlCamera

    ```js
    <b-new-b-icon-control-camera />
    ```
</docs>


